/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderTrackingItemDTOFromJSON, OrderTrackingItemDTOToJSON, } from './OrderTrackingItemDTO';
/**
 * Check if a given object implements the PaginatedResponseOrderTrackingItemDTO interface.
 */
export function instanceOfPaginatedResponseOrderTrackingItemDTO(value) {
    return true;
}
export function PaginatedResponseOrderTrackingItemDTOFromJSON(json) {
    return PaginatedResponseOrderTrackingItemDTOFromJSONTyped(json, false);
}
export function PaginatedResponseOrderTrackingItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(OrderTrackingItemDTOFromJSON)),
    };
}
export function PaginatedResponseOrderTrackingItemDTOToJSON(json) {
    return PaginatedResponseOrderTrackingItemDTOToJSONTyped(json, false);
}
export function PaginatedResponseOrderTrackingItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(OrderTrackingItemDTOToJSON)),
    };
}
